import React,{ useState,useEffect } from 'react';
import MenuSelectProductType from './MenuSelectProduct';
import MenuProductView from './MenuProductView';
import MenuPositions from './MenuPosition';
import AnimationBtn from './AnimationBtn';
import Howtousenew from './Howtousenew';
import HowToUse from './HowToUse';
import FooterControl from './FooterControl';
import FooterControlMob from './FooterControlMob';
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';
import useWindowDimensions from '../../WindowDimensions';
import { HorizontalSplit } from '@material-ui/icons';

// import MenuBtn from './MenuBtn';
// import { MicNone } from '@material-ui/icons'; 
var mob = (navigator.userAgent.indexOf("iPhone") != -1) || ((navigator.userAgent.indexOf("Android") != -1)) ||
   (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15");
var mobPortrait = (mob && window.innerHeight > window.innerWidth);
var moblandscap = (mob && window.innerWidth > window.innerHeight);
var isipad = (/CriOS/i.test(navigator.userAgent) && /ipad/i.test(navigator.userAgent)) || (navigator.userAgent.indexOf('iPad') != -1) ||
   (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2);

export const userContext = React.createContext();
var prevCounter = 0;
var nextClicked = false;
var prevClicked = false;
var buttonSeq = ['onResetMode','onFrontClick','onBackClick','onRightClick','onLeftClick','onTopClick','onBottomClick','onInternalClick'];
var buttonSeq180 = ['onResetMode','onFrontClick','onBackClick','onRightClick','onLeftClick','onTopClick','onBottomClick','onInternalClick'];


var position = {
   'currentPos': 'reset',
   'close': 0.041,
   'nintyDegree': 1.0833334,
   'reset': 2.082,
   'top': 1.25,

}
var reflectionGpState = "vertical";
var reflectionGpStateFrom;
// var position = {
//    'currentPos': 'reset',
//    'close': 0,
//    'nintyDegree': 1.04167,
//    'reset': 2.08333,
//    'top': 1.583,
//    'tent': 3.125,
//    'theatre': 4.1667,
//    'tablet': 5.208,
// }

const MainMenu = (props) => {
   const [expandedPanel,setExpandedPanel] = useState(false);
   const [displayed,setDisplayed] = useState(false);
   const [hidden,setHidden] = useState(true);
   const [laptop360FrontImg,setLaptop360FrontImg] = useState("./img/front.png");
   const [laptop360TopImg,setLaptop360TopImg] = useState("./img/top.png");
   const [laptop360LeftImg,setLaptop360LefttImg] = useState("./img/left.png");
   const [laptop360RightImg,setLaptop360RightImg] = useState("./img/right.png");
   const [laptop360BackImg,setLaptop360BackImg] = useState("./img/back.png");
   const [laptop360BottomImg,setLaptop360BottomImg] = useState("./img/bottom.png");
   const [laptop360InternalImg,setLaptop360InternalImg] = useState("./img/internal.png");
   const [counter,setCounter] = useState(0);
   const [selectedButton,setSelectedButton] = useState('onResetMode');


   const handleAccordionChange = (panel) => (event,isExpanded) => {
      //  console.log({ event,isExpanded });
      //setExpandedPanel(isExpanded ? panel  : false );
      if (isExpanded) {
         setExpandedPanel(panel);
         //console.log("shubham");
      } else {
         //  console.log("Pawar");
         setExpandedPanel(false)
      };


   };
   const [camData,setCamData] = useState("");
   var animationSwitch = window.Animation;
   var animTime = 1;
   var animTimes = 1;

   const getData = () => {
      fetch('./model_gl/config.json')
         .then(function (response) {
            return response.json();
         })
         .then(function (myJson) {
            // console.log(myJson.positions);
            setCamData(myJson.positions);
         });
   }
   useEffect(() => {
      getData();
      animationSwitch = window.Animation;
      moblandscap = (mob && window.innerWidth > window.innerHeight);

       window.position = 'reset';
   },[]);

   useEffect((event) => {
      if (event) {
         if (event.keyCode == 13) {
            this.click();
         }
      }
      // alert('Counter in useEffect'+prevCounter);
      // alert('Counter in useEffect'+counter);
      window.addEventListener('mousedown',() => {
         //  //document.getElementById('calloutcanvas').style.display = "none";
          window.hotspot = '';
      })
      return () => {
         window.removeEventListener('mousedown',() => {
            // //document.getElementById('calloutcanvas').style.display = "none";
             window.hotspot = '';
         })
      }

   },[])
   useEffect((event) => {
      if (event) {
         if (event.keyCode == 13) {
            this.click();
         }
      }
      var isipad = (/CriOS/i.test(navigator.userAgent) && /ipad/i.test(navigator.userAgent)) || (navigator.userAgent.indexOf('iPad') != -1) ||
         (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2);

      let mob = (navigator.userAgent.indexOf("iPhone") != -1) || ((navigator.userAgent.indexOf("Android") != -1)) ||
         (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15");

      // alert('Counter in useEffect'+prevCounter);
      // alert('Counter in useEffect'+counter);

   })

   //For Animation Switch 
   // console.log('animationSwitch anim', animationSwitch)

   if (animationSwitch == 'on') { animTime = 1000; animTimes = 2000 }
   else { animTime = 1; animTimes = 1 }
   // console.log('animTime', animTime)

   //new camera function
   const GotoPosInTimeNamedValue = (gotoposname,onComplete,onSample) => {
      // below code is updated in it.  
      // updated code ends here
      // console.log(gotoposname)
      var opt = undefined,gp = camData[gotoposname];

      //    console.log(gp)
      if (gp.fovy && window.scene.fovy != gp.fovy)
         opt = { fovy: gp.fovy };
      if (gp.pos.length > 5) {
         if (!opt)
            opt = {};
         opt.zang = gp.pos[5];
      }
      // console.log('animationSwitch', animationSwitch)
      let increase = 0;
      if (animationSwitch == 'off') {
         gp.time = 1
         // console.log('animationSwitch iffff', gp.time)
      }
      else {
         gp.time = animTime;
         // console.log('animationSwitch elseeee', gp.time)
      }
      if (window.mob || window.isipad) {
       
         if ( gotoposname == 'Render_Cam_F10_L'
            || gotoposname == 'Render_Cam_F10_R' ) {

            // increase = 25;
            increase = 13;
         }
         else if(gotoposname == 'Render_Cam_F01_Rear' || gotoposname == 'Render_Cam_F01_F'  ){
            increase = 70;
         }
         else if(gotoposname == 'Render_Cam_F01_Back_Port'||  gotoposname == 'Render_Cam_F10_Front_Port' ){
            increase = 40
         }
         else{
            increase = 13
         }
      }
      else{
         if ( gotoposname == 'Render_Cam_F01_Rear'|| gotoposname == 'Render_Cam_F01_F') {
            // console.log("desktop");

            increase = 15;
         }

      
      }
      
      window.scene.gotoPosInTime(gp.pos[0],gp.pos[1],gp.pos[2],gp.pos[3],gp.pos[4] + increase,gp.time,onComplete,slowInOut,opt);
     
   }
   //end
   const slowInOut = (x) => {
      var a = 2.1;
      var x2 = 1.0 - x;
      var px = Math.pow(x,a);
      var px2 = Math.pow(x2,a);

      return px / (px + px2);
   }


   const reverseAll = () => {
      // window.scene._nav._navMaxDolly = 28.0; //110   
      window.scene._nav._navMinDolly = 9;
      window.scene._nav._navMaxDolly = 22;
      window.scene._nav._navRotationSpeed = 0.015;
      window.scene._nav._panMax = [16,12];    //[left, bottom];
      window.scene._nav._panMin = [-16,-5];  //[right, top];
      window.hotspot = '';

      window.scene.groupApplyState("SSD_COVER_ON");
      window.scene.groupApplyState("INTERNAL_OFF");
      window.scene.groupApplyState("SCREEN_ON");
      window.scene.groupApplyState("Spot_light_ON");

      window.scene.animPlayInTime("RUGGED_TAB_7230",0,1000);
      window.scene.animPlayInTime("Reflection_Box",0,1000);

      window.scene.animPlayInTime("BATTERY",0,1000);
      window.scene.animPlayInTime("A",0,1000);
      window.scene.animPlayInTime("B",0,1000);
      window.scene.animPlayInTime("C",0,1000);
      window.scene.animPlayInTime("D",0,1000);
      window.scene.animPlayInTime("E",0,1000);

      window.scene.animPlayInTime("Bottam_Cover",0,1000);
      window.scene.animPlayInTime("SCREEN",0,1000);
      window.scene.animPlayInTime("RUGGED_TAB_7230",0,1000);
      window.scene.animPlayInTime("Cover",0,1000);
      window.scene.animPlayInTime("LAN_PART",0,1000);
      window.scene.animPlayInTime("Corner_Parts",0,1000);
      window.scene.animPlayInTime("_REAR_CAM_INTERNAL",0,1000);
      window.scene.animPlayInTime("SPEKER",0,1000);
      window.scene.animPlayInTime("USB_PORT1",0,1000);
      window.scene.animPlayInTime("HDMI",0,1000);
      window.scene.animPlayInTime("DELL_407",0,1000);
      window.scene.animPlayInTime("MB_BOARDS",0,1000);
      window.scene.animPlayInTime("Heatsink_Fan",0,1000);
      window.scene.animPlayInTime("Bottam_Cover",0,1000);
      window.scene.animPlayInTime("SCREEN",0,1000);
      window.scene.animPlayInTime("Reflection_Box ",0.0416667,1000);
      window.scene.animPlayInTime("GP",0.0416667,1000);
      window.scene.animPlayInTime("Daynmic_Ref_plane",0.0416667,1000);
      window.scene.clearRefine();

   }

   const hideShowReflectionGp = () => {

      if (reflectionGpState == "vertical") {
       //  console.log("reflectionGpState ===vertical");



         if (reflectionGpStateFrom == "verticalToVertical") {
            // console.log("reflectionGpStateFrom ===verticalToVertical");
            window.scene.groupApplyState("GP_ON");
            window.scene.groupApplyState("GP_RESET_ON");
            window.scene.groupApplyState("REF_BOX_ON");
         }
         else if (reflectionGpStateFrom == "horizontalToVertical") {
            // console.log("reflectionGpStateFrom ===horizontalToVertical");
            window.scene.groupApplyState("GP_OFF");
            window.scene.groupApplyState("GP_RESET_OFF");
            window.scene.groupApplyState("REF_BOX_OFF");
         }
      }
      else if (reflectionGpState == "horizontal") {
         // console.log("reflectionGpState ===horizontal");

         if (reflectionGpStateFrom == "verticalToHorizontal") {
            // console.log("reflectionGpStateFrom ===verticalToHorizontal");
            window.scene.groupApplyState("GP_OFF");
            window.scene.groupApplyState("GP_RESET_OFF");
            window.scene.groupApplyState("REF_BOX_OFF");
         }
         else if (reflectionGpStateFrom == "horizontalToHorizontal") {
            // console.log("reflectionGpStateFrom ===horizontalToHorizontal");
            window.scene.groupApplyState("REF_BOX_ON");
            window.scene.groupApplyState("GP_F10_ON");
         }

      }
      else if (reflectionGpState == "explode") {
         // console.log("reflectionGpState ===explode")
         window.scene.groupApplyState("REF_BOX_OFF");
         window.scene.groupApplyState("GP_OFF");
      }

   }

   //MenuProductView

   const onFrontClick = (isNextPrevious) => {

      //Update ZoomBar
      reverseAll();
      if (reflectionGpState == "vertical") {
         reflectionGpStateFrom = "verticalToVertical";

      }
      else if (reflectionGpState == "horizontal") {
         reflectionGpStateFrom = "horizontalToVertical";

      }
      reflectionGpState = "vertical";
      hideShowReflectionGp();

      if (reflectionGpState == "vertical") {
         reflectionGpStateFrom = "verticalToVertical";

      }
      else if (reflectionGpState == "horizontal") {
         reflectionGpStateFrom = "horizontalToVertical";

      }
      // window.scene._nav._navMaxDolly = 29.0; //110
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('frontBtn').classList.add('active');
      //  window.position = 'reset';
      window.hotspot = '';


      var currentPosName = position.currentPos;

      setSelectedButton('onFrontClick');
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Front view');

         document.getElementById('nextView').setAttribute('aria-label','Front view');
      }

      window.scene.clearRefine();

      GotoPosInTimeNamedValue(window.config.front,function () {
         //window.scene.animPlayInTime("Daynmic_Ref_plane",0.0416667,1000);
         window.scene.animPlayInTime("Reflection_Box",0,1000);
         hideShowReflectionGp();
         // var center = [0, 0, 0];
         // window.scene._nav.SetRotationCenter(center);
         window.hotspot = 'front';


         if (isNextPrevious != true) {
            // alert("isNextPrevious");
            window.document.getElementById("hotspot1demo").focus();
         }
      })
      if (!(window.isipad || window.mob)) {
         for (let i = 1; i <= document.querySelectorAll(".hotspots").length; i++) {
            if (i === 2) break;
            if (window.document.getElementById("hotspot" + i) !== null) {
               window.document.getElementById("hotspot" + i).setAttribute('tabindex',1);
            }
         }
      }
      window.RT_RecordEvent("Product View","Front",window.config.name);
      window.scene.clearRefine();

   }

   const onBackClick = (isNextPrevious) => {
      reverseAll();
      //Update ZoomBar
      // console.log("back")
      if (reflectionGpState == "vertical") {
         reflectionGpStateFrom = "verticalToVertical";

      }
      else if (reflectionGpState == "horizontal") {
         reflectionGpStateFrom = "horizontalToVertical";

      }
      reflectionGpState = "vertical";
      hideShowReflectionGp();

      if (reflectionGpState == "vertical") {
         reflectionGpStateFrom = "verticalToVertical";

      }
      else if (reflectionGpState == "horizontal") {
         reflectionGpStateFrom = "horizontalToVertical";

      }
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      document.getElementById('backBtn').classList.add('active');
       window.position = 'reset';
      var currentPosName = position.currentPos;

      setSelectedButton('onBackClick');
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Front view');

         document.getElementById('nextView').setAttribute('aria-label','Front view');
      }



      GotoPosInTimeNamedValue(window.config.back,function () {
         window.hotspot = 'back';

         window.scene.groupApplyState("SSD_COVER_OFF");
         window.scene.animPlayInTime("Reflection_Box",0,1000);
         hideShowReflectionGp();
         window.scene.clearRefine();

      })
      if (!(window.isipad || window.mob)) {
         for (let i = 1; i <= document.querySelectorAll(".hotspots").length; i++) {
            if (i === 2) break;
            if (window.document.getElementById("hotspot" + i) !== null) {
               window.document.getElementById("hotspot" + i).setAttribute('tabindex',1);
            }
         }
      }
      window.RT_RecordEvent("Product View","Back",window.config.name);
      window.scene.clearRefine();


   }

   const onRightClick = (isNextPrevious) => {

      reverseAll();
      // console.log("right")

      if (reflectionGpState == "vertical") {
         reflectionGpStateFrom = "verticalToHorizontal";

      }
      else if (reflectionGpState == "horizontal") {
         reflectionGpStateFrom = "horizontalToHorizontal";

      }
      reflectionGpState = "horizontal";
      hideShowReflectionGp();

      if (reflectionGpState == "vertical") {
         reflectionGpStateFrom = "verticalToHorizontal";

      }
      else if (reflectionGpState == "horizontal") {
         reflectionGpStateFrom = "horizontalToHorizontal";

      }

      //Update ZoomBar
      //   console.log(position.nintyDegree,position.currentPos)

      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      setSelectedButton('onRightClick');
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','right view');

         document.getElementById('nextView').setAttribute('aria-label','right view');
      }
      //document.getElementById('calloutcanvas').style.display = "none";
       window.hotspot = '';
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('rightBtn').classList.add('active');


       window.position = 'reset';
      // window.scene.animPlayInTime("Daynmic_Ref_plane",0.4160000,1000);
      window.scene.groupApplyState("Spot_light_OFF");

      window.scene.animPlayInTime("RUGGED_TAB_7230",0.4166667,1000,function () {

      });
      window.scene.animPlayInTime("GP",0.4160000,500);
      //window.scene.animPlayInTime("RUGGED_TAB_7230",0.4160000,1000);
      window.scene.animPlayInTime("Reflection_Box",0.4160000,500);
      window.scene.animPlayInTime("Daynmic_Ref_plane",0.4160000,500,function () {


      });
      GotoPosInTimeNamedValue(window.config.left,function () {
         hideShowReflectionGp();
         // var center = [0, 42.8355, 2.3922];
         // window.scene._nav.SetRotationCenter(center);
         // setTimeout(function () {


         // },1600);







         window.scene.animPlayInTime("D",0.833,1500);
         window.scene.animPlayInTime("E",0.833,1500,() => {

            
            window.hotspot = 'right';
         });
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }

      });

      if (!(window.isipad || window.mob)) {
         for (let i = 1; i <= document.querySelectorAll(".hotspots").length; i++) {
            if (i === 2) break;
            if (window.document.getElementById("hotspot" + i) !== null) {
               window.document.getElementById("hotspot" + i).setAttribute('tabindex',1);
            }
         }
      }
      window.RT_RecordEvent("Product View","Right",window.config.name);
      window.scene.clearRefine();

   }
   const onLeftClick = (isNextPrevious) => {

      reverseAll();

      // console.log("left");
      if (reflectionGpState == "vertical") {
         reflectionGpStateFrom = "verticalToHorizontal";

      }
      else if (reflectionGpState == "horizontal") {
         reflectionGpStateFrom = "horizontalToHorizontal";

      }
      reflectionGpState = "horizontal";
      hideShowReflectionGp();

      if (reflectionGpState == "vertical") {
         reflectionGpStateFrom = "verticalToHorizontal";

      }
      else if (reflectionGpState == "horizontal") {
         reflectionGpStateFrom = "horizontalToHorizontal";

      }
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      setSelectedButton('onLeftClick');
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','left view');

         document.getElementById('nextView').setAttribute('aria-label','left view');
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }


      document.getElementById('leftBtn').classList.add('active');
       window.position = 'reset';
      window.scene.groupApplyState("Spot_light_OFF");
      window.scene.animPlayInTime("RUGGED_TAB_7230",0.4166667,1000,function () {

      });
      window.scene.animPlayInTime("GP",0.4160000,500);
      //window.scene.animPlayInTime("RUGGED_TAB_7230",0.4160000,1000);
      window.scene.animPlayInTime("Reflection_Box",0.4160000,500);
      window.scene.animPlayInTime("Daynmic_Ref_plane",0.4160000,500,function () {

      });

      GotoPosInTimeNamedValue(window.config.right,function () {
         // var center = [0, 89.9998, -1];
         // window.scene._nav.SetRotationCenter(center);
         hideShowReflectionGp();

         window.scene.animPlayInTime("A",0.833,1500);
         window.scene.animPlayInTime("B",0.833,1500);
         setTimeout(function () {
            window.hotspot = 'left';
         },1600);

         window.scene.clearRefine();
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }

      });
      if (!(window.isipad || window.mob)) {
         for (let i = 1; i <= document.querySelectorAll(".hotspots").length; i++) {
            if (i === 2) break;
            if (window.document.getElementById("hotspot" + i) !== null) {
               window.document.getElementById("hotspot" + i).setAttribute('tabindex',1);
            }
         }
      }
      //  window.scene.animPlayInTime("DELL_INSPIRON_ODIN_13_INCH.001",1.0833334,1000);
      window.RT_RecordEvent("Product View","Left",window.config.name);
      window.scene.clearRefine();

   }



   const onTopClick = (isNextPrevious) => {
      //Update ZoomBar
      reverseAll();
      if (reflectionGpState == "vertical") {
         reflectionGpStateFrom = "verticalToHorizontal";

      }
      else if (reflectionGpState == "horizontal") {
         reflectionGpStateFrom = "horizontalToHorizontal";

      }
      reflectionGpState = "horizontal";
      hideShowReflectionGp();

      if (reflectionGpState == "vertical") {
         reflectionGpStateFrom = "verticalToHorizontal";

      }
      else if (reflectionGpState == "horizontal") {
         reflectionGpStateFrom = "horizontalToHorizontal";

      }
      //  console.log(position.top,position.currentPos)

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      setSelectedButton('onTopClick');
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Top view');

         document.getElementById('nextView').setAttribute('aria-label','Top view');
      }


      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('topBtn').classList.add('active');
       window.position = 'reset';
      window.scene.groupApplyState("Spot_light_OFF");
      window.scene.animPlayInTime("RUGGED_TAB_7230",0.4166667,1000);
      // window.scene.animPlayInTime("Reflection_Box",0.4160000,1000);
      window.scene.animPlayInTime("GP",0.4160000,1000);
      //window.scene.animPlayInTime("RUGGED_TAB_7230",0.4160000,1000);
      window.scene.animPlayInTime("Reflection_Box",0.4160000,1000);
      window.scene.animPlayInTime("Daynmic_Ref_plane",0.4160000,1500,function () {

      });
      GotoPosInTimeNamedValue(window.config.top,function () {
         hideShowReflectionGp();

         window.scene.animPlayInTime("C",0.833,1500);
         window.scene.clearRefine();
         setTimeout(function () {
            window.hotspot = 'top';
         },1600);

         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }

      });


      if (!(window.isipad || window.mob)) {
         for (let i = 1; i <= document.querySelectorAll(".hotspots").length; i++) {
            if (i === 2) break;
            if (window.document.getElementById("hotspot" + i) !== null) {
               window.document.getElementById("hotspot" + i).setAttribute('tabindex',1);
            }
         }
      }
      window.RT_RecordEvent("Product View","Top",window.config.name);
      window.scene.clearRefine();

   }



   const onBottomClick = (isNextPrevious) => {
      //Update ZoomBar
      reverseAll();
      //  console.log(position.top,position.currentPos)
      if (reflectionGpState == "vertical") {
         reflectionGpStateFrom = "verticalToHorizontal";

      }
      else if (reflectionGpState == "horizontal") {
         reflectionGpStateFrom = "horizontalToHorizontal";

      }
      reflectionGpState = "horizontal";
      hideShowReflectionGp();

      if (reflectionGpState == "vertical") {
         reflectionGpStateFrom = "verticalToHorizontal";

      }
      else if (reflectionGpState == "horizontal") {
         reflectionGpStateFrom = "horizontalToHorizontal";

      }
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      setSelectedButton('onBottomClick');
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Bottom view');

         document.getElementById('nextView').setAttribute('aria-label','Bottom view');
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('bottomBtn').classList.add('active');
       window.position = 'reset';

      // window.scene.animPlayInTime("RUGGED_TAB_7230",0.4166667,1000);
      // window.scene.animPlayInTime("Reflection_Box",0.4166667,1000);
      window.scene.groupApplyState("Spot_light_OFF");
      window.scene.animPlayInTime("RUGGED_TAB_7230",0.4166667,1000);
      window.scene.animPlayInTime("GP",0.4160000,1000);
      window.scene.animPlayInTime("Reflection_Box",0.4160000,1000);
      window.scene.animPlayInTime("Daynmic_Ref_plane",0.4160000,1500,function () {

      });
      GotoPosInTimeNamedValue(window.config.bottom,function () {
         window.hotspot = 'bottom';
         hideShowReflectionGp();
      });

      if (!(window.isipad || window.mob)) {
         for (let i = 1; i <= document.querySelectorAll(".hotspots").length; i++) {
            if (i === 2) break;
            if (window.document.getElementById("hotspot" + i) !== null) {
               window.document.getElementById("hotspot" + i).setAttribute('tabindex',1);
            }
         }
      }
      window.RT_RecordEvent("Product View","Bottom",window.config.name);
      window.scene.clearRefine();

   }
   const onInternalClick = (isNextPrevious) => {
      //Update ZoomBar
      reverseAll();
      reflectionGpState = "explode";
      hideShowReflectionGp();
      //  console.log(position.top,position.currentPos)
      window.scene._nav._navMinDolly = 16;
      window.scene._nav._navMaxDolly = 34;
      window.scene._nav._navRotationSpeed = 0.03;
      window.scene._nav._panMax = [16,6];    //[left, bottom];
      window.scene._nav._panMin = [-16,-10];  //[right, top];

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      setSelectedButton('onInternalClick');
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Internal view');

         document.getElementById('nextView').setAttribute('aria-label','Internal view');
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('internalBtn').classList.add('active');

      window.scene.groupApplyState("Spot_light_OFF");
      window.scene.animPlayInTime("RUGGED_TAB_7230",0.4166667,1000,function () {

      });
      GotoPosInTimeNamedValue(window.config.internal,function () {

         window.scene.groupApplyState("INTERNAL_ON");
         window.scene.groupApplyState("SCREEN_OFF");
         window.scene.animPlayInTime("RUGGED_TAB_7230",0.4166667,1000);
         window.scene.animPlayInTime("Cover",1.6660000,1000);
         window.scene.animPlayInTime("LAN_PART",1.6660000,1000);
         window.scene.animPlayInTime("Corner_Parts",1.6660000,1000);
         window.scene.animPlayInTime("_REAR_CAM_INTERNAL",1.6660000,1000);
         window.scene.animPlayInTime("SPEKER",1.6660000,1000);
         window.scene.animPlayInTime("USB_PORT1",1.6660000,1000);
         window.scene.animPlayInTime("HDMI",1.6660000,1000);
         window.scene.animPlayInTime("DELL_407",1.6660000,1000);
         window.scene.animPlayInTime("MB_BOARDS",1.6660000,1000);
         window.scene.animPlayInTime("Heatsink_Fan",1.6660000,1000);
         window.scene.animPlayInTime("Bottam_Cover",1.6660000,1000);
         window.scene.animPlayInTime("BATTERY",1.6660000,1000);
         window.scene.animPlayInTime("SCREEN",1.6660000,1000);

         setTimeout(function () {
            window.hotspot = 'internal';
         },1200);
         window.scene.clearRefine();
      });

      if (!(window.isipad || window.mob)) {
         for (let i = 1; i <= document.querySelectorAll(".hotspots").length; i++) {
            if (i === 2) break;
            if (window.document.getElementById("hotspot" + i) !== null) {
               window.document.getElementById("hotspot" + i).setAttribute('tabindex',1);
            }
         }
      }
      window.RT_RecordEvent("Product View","Internals",window.config.name);
      window.scene.clearRefine();

   }


   const [nextClick,setNextClick] = useState(false);
   const [prevClick,setPrevClick] = useState(false);


   const resetMode = () => {
      setSelectedButton('onResetMode');
      GotoPosInTimeNamedValue('Render_Cam_F01_FL',function () { })
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Reset Mode');

         document.getElementById('nextView').setAttribute('aria-label','Reset Mode');
      }
   }

   const onResetMode = () => {
      //Update ZoomBar
      //   console.log(position.tent,position.currentPos)

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      if (selectedButton == 'onFrontClick') {
         onFrontClick();
      }
      else if (selectedButton == 'onBackClick') {
         onBackClick();
      }
      else if (selectedButton == 'onTopClick') {
         onTopClick();
      }
      else if (selectedButton == 'onBottomClick') {
         onBottomClick();
      }
      else if (selectedButton == 'onRightClick') {
         onRightClick();
      }
      else if (selectedButton == 'onLeftClick') {
         onLeftClick();
      }
      else if (selectedButton == 'onInternalClick') {
         onInternalClick();
      }

      else if (selectedButton == 'onResetMode') {
         resetMode();
      }

      window.scene.clearRefine();

   }

   const onPreviousMode = () => {

      //Update ZoomBar
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      var prevButton;
      var selectedButtonIndex = buttonSeq180.findIndex(element => element == selectedButton)
      if (selectedButton == 'onFrontClick' || selectedButton == 'onResetMode') {
         prevButton = 'onInternalClick';
      } else {
         prevButton = buttonSeq180[selectedButtonIndex - 1];
      }
      var prevButton;
      var selectedButtonIndex = buttonSeq.findIndex(element => element == selectedButton)
      if (selectedButton == 'onFrontClick' || selectedButton == 'onResetMode') {
         prevButton = 'onInternalClick';
      } else {
         prevButton = buttonSeq[selectedButtonIndex - 1];
      }

      if (prevButton == 'onFrontClick') {
         setExpandedPanel("panel1");
         onFrontClick(true);
      }
      else if (prevButton == 'onTopClick') {
         setExpandedPanel("panel1");
         onTopClick(true);
      }
      else if (prevButton == 'onBackClick') {
         setExpandedPanel("panel1");
         onBackClick()
      }
      else if (prevButton == 'onRightClick') {
         setExpandedPanel("panel1");
         onRightClick(true);
      }
      else if (prevButton == 'onLeftClick') {
         setExpandedPanel("panel1");
         onLeftClick(true);
      }
      else if (prevButton == 'onBottomClick') {
         setExpandedPanel("panel1");
         onBottomClick(true);
      }
      else if (prevButton == 'onInternalClick') {
         setExpandedPanel("panel1");
         onInternalClick(true);
      }
   }

   const onNextMode = () => {

      //Update ZoomBar
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         slider.value = window.scene._nav.getZoomFactor();
         setTimeout(function () { slider.value = window.scene._nav.getZoomFactor(); },1000);
      }

      var nextButton;
      var selectedButtonIndex = buttonSeq180.findIndex(element => element == selectedButton)
      if (selectedButton == 'onInternalClick') {
         nextButton = 'onFrontClick';
      } else {
         nextButton = buttonSeq180[selectedButtonIndex + 1];
      }


      var nextButton;
      var selectedButtonIndex = buttonSeq.findIndex(element => element == selectedButton)
      if (selectedButton == 'onInternalClick') {
         nextButton = 'onFrontClick';
      } else {
         nextButton = buttonSeq[selectedButtonIndex + 1];
      }


      if (nextButton == 'onFrontClick') {
         setExpandedPanel("panel1");
         onFrontClick(true);
      }
      else if (nextButton == 'onTopClick') {
         setExpandedPanel("panel1");
         onTopClick(true);
      }
      else if (nextButton == 'onRightClick') {
         setExpandedPanel("panel1");
         onRightClick(true);
      }
      else if (nextButton == 'onBackClick') {
         setExpandedPanel("panel1");
         onBackClick(true);
      }
      else if (nextButton == 'onLeftClick') {
         setExpandedPanel("panel1");
         onLeftClick(true);
      }
      else if (nextButton == 'onBottomClick') {
         setExpandedPanel("panel1");
         onBottomClick(true);
      }

      else if (nextButton == 'onInternalClick') {
         setExpandedPanel("panel1");
         onInternalClick(true);
      }


   }

   const [animValue,setAnimValue] = useState("On");

   const [animValue1,setAnimValue1] = useState("On");

   useEffect(() => {
      // console.log('useeffect working');
      window.Animation = 'on';
      setAnimValue("On");
      document.getElementById("animSwitchValue").checked = true;
      document.getElementsByClassName('onOff')[0].style.left = "-17px";
      if (!(window.mob)) {
         document.getElementById("animSwitchValue1").setAttribute('aria-label','Animation On')
         // document.getElementById('animSwitchValue1').setAttribute('aria-label','clickable checkbox checked On');

         setAnimValue1("On");
         document.getElementById("animSwitchValue1").checked = true;
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";
      }
   },[]);

   const setAnimationSwitch = (e) => {
      //  console.log(e)
      // displayName(e);
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked == true) {
         //document.getElementById("animSwitchValue").setAttribute('aria-label', 'Animation Off');
         document.getElementById("animSwitchValue").checked = false;
         setAnimValue("Off");
         document.getElementsByClassName('onOff')[0].style.left = "9px";
         window.Animation = 'off';

         // alert("Animation On");

      } else {
         // document.getElementById("animSwitchValue").setAttribute('aria-label', 'Animation On')
         document.getElementById("animSwitchValue").checked = true;

         setAnimValue("On");
         window.Animation = 'on';
         document.getElementsByClassName('onOff')[0].style.left = "-17px";
         // alert("Animation Off");

      }
   }
   const displayName = (e) => {
      //  console.log(e)
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked == true) {
         setAnimValue("On");
         window.Animation = 'on';
         document.getElementsByClassName('onOff')[0].style.left = "-17px";
         document.getElementById('animSwitchValue').setAttribute('aria-label','clickable checkbox checked On');
         // alert("Animation On");

      } else {
         setAnimValue("Off");
         document.getElementsByClassName('onOff')[0].style.left = "9px";
         window.Animation = 'off';
         document.getElementById('animSwitchValue').setAttribute('aria-label','clickable checkbox checked Off');
         // alert("Animation Off");

      }

   }
   const setAnimationSwitch1 = (e) => {
      // console.log(e)
      // displayName(e);
      const isChecked = document.getElementById("animSwitchValue1").checked;

      if (isChecked == true) {
         //document.getElementById("animSwitchValue").setAttribute('aria-label', 'Animation Off');
         document.getElementById("animSwitchValue1").checked = false;
         setAnimValue1("Off");
         // keyboardOff();
         document.getElementsByClassName('onOff1')[0].style.left = "9px";
         window.animationSwitchVal = 'off';
         window.animationSwitchGlobal = 'off';


      } else {
         // document.getElementById("animSwitchValue").setAttribute('aria-label', 'Animation On')
         document.getElementById("animSwitchValue1").checked = true;

         setAnimValue1("On");
         window.animationSwitchVal = 'on';
         // keyboardOn();
         window.animationSwitchGlobal = 'on';
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";




      }
   }
   var animStopped = true;
   const displayName1 = (e) => {
      if (animStopped == false) {
         return;
         animStopped = false;
      }
      // console.log(e)
      const isChecked = document.getElementById("animSwitchValue1").checked;

      if (isChecked == true) {
         setAnimValue1("On");
         // keyboardOn();
         window.animation1SwitchGlobal = 'on';
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";
         document.getElementById('animSwitchValue1').setAttribute('aria-label','clickable checkbox checked On');
         window.animationSwitchVal = 'on';

         if (mob) {
            document.getElementById('footerControls').removeAttribute('style');
            document.getElementById('footerControMob').style.display = 'block';
         }
         else if (isipad) {
            // console.log('portrait');
            document.getElementById('footerControMob').style.display = 'block';
            document.getElementById('footerControls').style.display = 'block';
         }
         else {
            //  console.log("show");

            document.getElementById('footerControls').style.transition = "bottom 0.2s linear";
            document.getElementById('footerControls').style.bottom = "20px";

            document.getElementById('footerControls').style.visibility = "";
            document.getElementById('footerControIpad').style.visibility = "";
         }


      } else {
         setAnimValue1("Off");
         // keyboardOff();
         document.getElementsByClassName('onOff1')[0].style.left = "9px";
         window.animation1SwitchGlobal = 'off';

         document.getElementById('animSwitchValue1').setAttribute('aria-label','clickable checkbox checked Off');

         if (mob) {
            document.getElementById('footerControls').removeAttribute('style');
            document.getElementById('footerControMob').style.display = 'none';
         } else if (isipad) {
            // console.log('landscape');
            document.getElementById('footerControMob').style.display = 'none';
            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            // console.log("hide");
            document.getElementById('footerControls').style.transition = "bottom 0.2s linear";
            document.getElementById('footerControls').style.bottom = "-118px";
            setTimeout(function () {

               document.getElementById('footerControls').style.visibility = "hidden";
               document.getElementById('footerControIpad').style.visibility = "hidden";
               animStopped = true;
            },200);
         }

      }

   }
   return (
      <>
         {/* <Hidden only={["xs",'sm']}> */}
         {!window.mob && <HowToUse />}
         {/* </Hidden> */}
         <Hidden only={['sm','md','lg','xl']}>

            <Button style={{ position: 'fixed',backgroundColor: '#F0F0F0',width: '100%',height: '56px',paddingTop: '15px',paddingBottom: '15px',zIndex: '1',border: '1px solid #E1E1E1',borderLeft: "none",borderRight: "none",borderRadius: "0",margin: "-1px 0px 0px 0px" }}
               variant="outlined"
               color="primary"
               // className={classes.button}
               endIcon={<img src="./img/cross.svg" alt="cross" style={{ marginLeft: '207px',height: '23px' }} />}
               onClick={props.toggleDrawerAction}
            >
               {window.finalLangues.mainMenu}
            </Button>
            <Howtousenew />

         </Hidden >
         <Hidden only={['md','lg','xl','xs']}>
            {moblandscap && <Howtousenew />}
         </Hidden>

         <Hidden only={["xs"]}>
            <FooterControl name="reset and next previous" onReset={onResetMode} onPrevious={onPreviousMode} onNext={onNextMode} />
         </Hidden>
         <Hidden only={['lg','xl']}>
            <FooterControlMob onResetMob={onResetMode} onPreviousMob={onPreviousMode} onNextMob={onNextMode} onResetIpad={onResetMode} onNextIpad={onNextMode} onPreviousIpad={onPreviousMode} />
         </Hidden>
         <MenuProductView tabIndex="1" onFrontBtnClick={onFrontClick} onTopBtnClick={onTopClick} onLeftBtnClick={onLeftClick} onRightBtnClick={onRightClick} onBackBtnClick={onBackClick}
            onBottomBtnClick={onBottomClick} onInternalBtnClick={onInternalClick} imgfront={laptop360FrontImg} imgtop={laptop360TopImg} imgleft={laptop360LeftImg} imgright={laptop360RightImg} imgback={laptop360BackImg} imgbottom={laptop360BottomImg} imginternal={laptop360InternalImg} name={`${window.finalLangues.productview}`} expanded={expandedPanel == 'panel1'} onChanged={handleAccordionChange('panel1')} />

         <AnimationBtn onchange={displayName} forKeypress={setAnimationSwitch} value={animValue} onchange1={displayName1} forKeypress1={setAnimationSwitch1} value1={animValue1} />
      </>
   );
}

export default MainMenu;